// Decorative confetti burst for celebratory moments ("I'm going").
// Loaded lazily so the library never runs during server rendering, and
// skipped entirely for people who ask their device for reduced motion.
type ConfettiFn = typeof import("canvas-confetti");

let loaded: ConfettiFn | null = null;

async function loadConfetti(): Promise<ConfettiFn | null> {
  if (typeof window === "undefined") return null;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return null;
  if (!loaded) {
    loaded = ((await import("canvas-confetti")) as { default: ConfettiFn }).default;
  }
  return loaded;
}

export async function celebrate(): Promise<void> {
  try {
    const confetti = await loadConfetti();
    if (!confetti) return;
    const colors = ["#22d3ee", "#f472b6", "#67e8f9", "#f9a8d4"];
    confetti({
      particleCount: 90,
      spread: 75,
      startVelocity: 38,
      origin: { y: 0.7 },
      colors,
    });
    // A quick second volley from the other side for a fuller burst.
    window.setTimeout(() => {
      confetti({
        particleCount: 45,
        angle: 60,
        spread: 60,
        startVelocity: 42,
        origin: { x: 0, y: 0.75 },
        colors,
      });
      confetti({
        particleCount: 45,
        angle: 120,
        spread: 60,
        startVelocity: 42,
        origin: { x: 1, y: 0.75 },
        colors,
      });
    }, 180);
  } catch {
    // Purely decorative — never let it break the RSVP flow.
  }
}
